<mode-day-of-month-selector
  [dayOfMonth]="schedule.dayOfMonth"
  (dayOfMonthChanged)="dayOfMonthChanged.emit($event)"
></mode-day-of-month-selector>
<mode-time-with-time-zone-selector
  [schedule]="schedule"
  (timeChanged)="timeChanged.emit($event)"
></mode-time-with-time-zone-selector>
